import { Stack } from '@mui/material';

import Changelog from './Changelog';
import DedicatedDeployments from './DedicatedDeployments';
import Details from './Details';
import Learn from './Learn';
import ModelAPIs from './ModelAPIs';
import Training from './Training';
import { Content } from './styled';

function Overview() {
  return (
    <Stack direction="row" height="100%">
      <Content>
        <DedicatedDeployments />
        <ModelAPIs />
        <Training />
        <Learn />
        <Changelog />
      </Content>
      <Details />
    </Stack>
  );
}

export default Overview;
